import React, { useEffect, useRef } from "react";
import { Loader2, PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useGuestCall } from "@/hooks/useGuestCall.js";
import { CALL_STATES } from "@/calling/callConstants.js";
import CallPopup from "@/calling/components/CallPopup.jsx";

const GuestCallButton = ({ guestInfo }) => {
  const remoteAudioRef = useRef(null);
  const call = useGuestCall({ guestInfo, remoteAudioRef });
  const isBusy = call.callState !== CALL_STATES.idle;
  const isReady = call.registered && call.status === "connected";

  useEffect(() => {
    const handleDepartmentCall = (event) => {
      call.callDepartment(event.detail?.department || "Reception");
    };

    window.addEventListener("hotel:startGuestDepartmentCall", handleDepartmentCall);
    return () => {
      window.removeEventListener("hotel:startGuestDepartmentCall", handleDepartmentCall);
    };
  }, [call]);

  return (
    <>
      <Button
        type="button"
        size="sm"
        onClick={call.callReception}
        disabled={!guestInfo?.sessionId || !isReady || isBusy}
        className="gap-2 rounded-xl bg-[#923536] text-white shadow-sm hover:bg-[#7f2e2f]"
      >
        {isReady ? <PhoneCall className="h-4 w-4" /> : <Loader2 className="h-4 w-4 animate-spin" />}
        {isReady ? "Call reception" : "Connecting..."}
      </Button>
      <audio ref={remoteAudioRef} autoPlay playsInline />
      <CallPopup
        callState={call.callState}
        callInfo={call.callInfo}
        muted={call.muted}
        isHeld={call.isHeld}
        isRemoteHeld={call.isRemoteHeld}
        isTransferring={call.isTransferring}
        transferringDepartment={call.transferringDepartment}
        callDuration={call.callDuration}
        onAccept={call.acceptCall}
        onDecline={call.declineCall}
        onEnd={call.endCall}
        onToggleMute={call.toggleMute}
      />
    </>
  );
};

export default GuestCallButton;
